
import axios from 'axios'

let config = {
    env: (process.env.NODE_ENV==='production') ? 'NGINX_ENV' : 'development',
    stockbookUrl: (process.env.NODE_ENV==='production') ? 'NGINX_STOCKBOOK_URL' : '//localhost:8081',
    liveUrl: (process.env.NODE_ENV==='production') ? 'NGINX_LIVE_URL' : 'ws://localhost:8000'
}

const stockbookApi = function(authToken) {
        return axios.create({
                    baseURL: `${config.stockbookUrl}/api/v2`,
                    headers: {
                        'Authorization': 'Bearer ' + authToken      //localStorage.getItem('authToken')
                    }
                });
}

export default {
    stockbookApi: stockbookApi,
    config: config
}
